import React, { useState } from "react";
import CookieConsent, { Cookies } from "react-cookie-consent";
import { initializeAndTrack } from "gatsby-plugin-gdpr-cookies";
import { useLocation } from "@reach/router";

const CookiesBanner = () => {
  const pagelocation = useLocation();
  const [show, setShow] = useState(true);

  const available = Boolean(Cookies.get("gatsby-gdpr-google-analytics"));

  if (available || !show) return null;

  function acceptCookies() {
    Cookies.set("gatsby-gdpr-google-analytics", "true");
    initializeAndTrack(pagelocation);
    setShow(false);
  }

  function declineCookies() {
    Cookies.set("gatsby-gdpr-google-analytics", "false");
    setShow(false);
  }

  return (
    <CookieConsent disableStyles hideOnAccept hideOnDecline>
      <div className="max-w-xl md:max-w-2xl w-full px-2 md:px-5 fixed bottom-2 md:bottom-5 sm:right-5 z-50">
        <div className="w-full mb-2 sm:mb-5 border border-solid border-[#555555] rounded-3xl px- px-5 py-10 sm:py-10 sm:px-10 lg:px-20 bg-white space-y-3 font-lora">
          <h2 className="text-2xl font-semibold">
            Do you allow us to use cookies?{" "}
          </h2>
          <p>
            To ensure the best user experience, we kindly request your
            permission to use cookies on our website
          </p>
          <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3">
            <button
              className="border-btn-rounded no-underline w-fit"
              onClick={acceptCookies}
            >
              Accept
            </button>
            <button
              className="border-btn-rounded no-underline w-fit"
              onClick={declineCookies}
            >
              Decline Request
            </button>
          </div>
        </div>
      </div>
    </CookieConsent>
  );
};

export default CookiesBanner;
